import React from 'react';
import { differentiationData } from '../mock';

const Differentiation = () => {
  return (
    <section className="dark-full-container" style={{ paddingTop: '160px', paddingBottom: '160px' }}>
      <div className="dark-content-container">
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: 'var(--brand-primary)' }}>
            Why Teams Choose QuByt AI
          </h2>
          <p className="body-large" style={{ maxWidth: '900px', margin: '0 auto' }}>
            Six ways the platform reduces the time, risk, and effort of taking a business
            idea to a production application.
          </p>
        </div>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '50px',
          maxWidth: '1400px',
          margin: '0 auto'
        }}>
          {differentiationData.map((item, index) => (
            <div 
              key={item.id} 
              className="diff-card reveal"
              style={{
                position: 'relative',
                background: 'linear-gradient(135deg, var(--bg-secondary) 0%, rgba(var(--brand-primary-rgb), 0.05) 100%)',
                padding: '50px',
                overflow: 'hidden',
                transitionDelay: `${Math.min(index, 5) * 0.09}s`
              }}
            >
              {/* Title and Subtitle */}
              <h3 className="heading-1" style={{ 
                marginBottom: '8px',
                color: 'var(--brand-primary)'
              }}>
                {item.title}
              </h3>
              <p style={{
                fontSize: '18px',
                color: 'var(--text-primary)',
                marginBottom: '20px',
                fontWeight: 500
              }}>
                {item.subtitle}
              </p>

              {/* Metric Badge */}
              <div style={{
                display: 'inline-block',
                background: 'rgba(var(--brand-primary-rgb), 0.1)',
                border: '1px solid var(--brand-primary)',
                borderRadius: '20px',
                padding: '8px 16px',
                marginBottom: '24px'
              }}>
                <span style={{
                  color: 'var(--brand-primary)',
                  fontSize: '14px',
                  fontWeight: 600
                }}>
                  {item.metric}
                </span>
              </div>

              {/* Challenge */}
              <div style={{ marginBottom: '20px' }}>
                <h4 style={{
                  color: 'var(--text-secondary)',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  marginBottom: '8px'
                }}>
                  The Challenge
                </h4>
                <p style={{
                  color: 'var(--text-secondary)',
                  fontSize: '16px',
                  lineHeight: 1.5
                }}>
                  {item.challenge}
                </p>
              </div>

              {/* Approach */}
              <div style={{ marginBottom: '20px' }}>
                <h4 style={{
                  color: 'var(--brand-primary)',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  marginBottom: '8px'
                }}>
                  Our Approach
                </h4>
                <p style={{
                  color: 'var(--text-primary)',
                  fontSize: '16px',
                  lineHeight: 1.5,
                  fontWeight: 500
                }}>
                  {item.breakthrough}
                </p>
              </div>

              {/* Impact */}
              <div style={{
                background: 'var(--bg-primary)',
                border: '1px solid var(--brand-primary)',
                borderRadius: '6px',
                padding: '16px',
                marginTop: '24px'
              }}>
                <h4 style={{
                  color: 'var(--brand-primary)',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  marginBottom: '8px'
                }}>
                  Outcome
                </h4>
                <p style={{
                  color: 'var(--text-primary)',
                  fontSize: '15px',
                  lineHeight: 1.4,
                  fontWeight: 500,
                  margin: 0
                }}>
                  {item.impact}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentiation;